import { DateTime } from "luxon";
import { GetServerSideProps } from "next";
import Head  from "next/head";
import { MenuId } from "../../components/Header";
import Layout from "../../components/Layout";
import {ThreeDViewer, ThreeDViewerHandle} from "../../components/ThreeDViewer";
import { getThreeDModel, getUserInformation } from "../../lib/data";
import { RusAuthProps, RusContextProps, SubscriberLevel, ThreeDModel } from "../../lib/definitions";
import {Paper, Text} from "@mantine/core"
import styles from "./[model].module.scss"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faQuestionCircle, faCog, faExpandWide } from "@fortawesome/sharp-solid-svg-icons";
import { useRef } from "react";

type Data = {
    model : ThreeDModel
    dateProcessed: string
    }
  
  export default function ModelPage({data} : {data: Data} & RusAuthProps & RusContextProps)
  {
    const ref = useRef<ThreeDViewerHandle>(null);

    return(
        <>
        
        <Layout menuId={MenuId.online}>
  
  <Head>
      <title>{data.model.name} - a 3d model</title>
      <meta name="description" content={data.model.seoDescription}/>

      <meta property='og:title' content={`${data.model.name} - a 3d model from Raw Umber Studios`}/>
      <meta property='og:description' content={data.model.seoDescription}/>
      <meta property='og:image' content={data.model.previewFilename}/>
      <meta property='og:image-width' content='1080'/>
      <meta property='og:image-height' content='1080'/>

  </Head>
  <div className = {styles.mainContent}>
  <h1 className={styles.h1}>{data.model.name} - a 3D model</h1>
    <Text>{data.model.description}</Text>

    <Paper mt='xl' className={styles.instructions}>
      <Text>Click the <FontAwesomeIcon onClick={() => {ref.current?.showHelp()}} icon={faQuestionCircle}/> button on the viewer for instructions, the <FontAwesomeIcon onClick={()=>{ref.current?.showOptions()}} icon={faCog}/> button for settings, and the <FontAwesomeIcon onClick={()=>{ref.current?.fullScreen()}} icon={faExpandWide}/> button to go full screen.</Text>
    </Paper>

    <ThreeDViewer model={data.model} ref={ref}/>
  </div>

  </Layout>



        </>

    );
  }

export const getServerSideProps : GetServerSideProps = async (context)=>
{
    let user = await getUserInformation(context?.req?.headers.cookie);

    const slug = context.params?.model;

    if (!slug)
    {
        return {
            notFound: true
          } 
    }

    let model = await getThreeDModel(slug as string);

    if (!model)
    {
        return {
            notFound: true
          } 
    }

    let access = (user.logged_in && user.subscriber_level == SubscriberLevel.gold || !model.subscriberOnly);

    if (!access)
    {
        model.filename='';
        model.accessible = false;
    }
    else
    {
        model.accessible = true;
    }
    return {
      props: {
        data: 
        { 
            model: model,
            dateProcessed: DateTime.now().toISO()
        }
     }   

    }
}
